import type { AccountRelatedRow } from '~/services/ContractingService';

import type { AccountExpense } from './types';

export function toAccountExpense(row: AccountRelatedRow<'expenses'>): AccountExpense {
  return {
    createdDate: row.created_at,
    currency: row.currency,
    id: row.external_refs.salesforce,
    name: row.name,
    totalCost: row.total_cost,
    travelForm: row.travel_form?.name ?? null,
    type: row.type,
  };
}
